import { createSelector } from '@reduxjs/toolkit'
import { createDealDetailsSelector } from './dealSelectors'
import { CollateralBasketType, DealSubscriptionIdentifier } from 'api'

export const structuredSelector = createSelector(createDealDetailsSelector([DealSubscriptionIdentifier.STRUCTURED]), dealDetails =>
  dealDetails.filter(({ productSector }) => productSector?.basketType !== CollateralBasketType.GC_BESPOKE)
)
